import { useQuery } from 'urql';

import { SKILL_TAXONOMIES_LEVELS_QUERY } from '@revelio/data-access';

export const useAllCustomSkillLevels = (
  { pause }: { pause: boolean } = { pause: false }
) => {
  const [{ data, ...rest }] = useQuery({
    query: SKILL_TAXONOMIES_LEVELS_QUERY,
    pause,
  });

  return {
    levels: data?.selectionList?.skill_taxonomies?.labels_by_level ?? [],
    data,
    ...rest,
  };
};
